/**
 *
 * HomeBanner
 *
 */

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import media from '../../style/mediainjector';

import { FlexChild, ContainerFlex } from '../Blocks';
import badge from '../../images/news_badge.svg';

export const Badge = styled.img`
  display: block;
  width: 64px;
  height: 64px;
  position: absolute;
  top: -10px;
  left: -16px;
  ${media.lt480`
    width: 48px;
    height: 48px;
  `}
`;

const HomeBanner = (props) => {
  const {
    bgcolor,
    color,
    border,
    radius,
    bannerContent,
    navigateFunction,
  } = props;

  return (
    <FlexChild
      width="100%"
      margin="-10px 0 30px"
      padding="0 20px"
    >
      <ContainerFlex
        bgcolor={bgcolor}
        radius={radius}
        color={color}
        border={border}
        onClick={navigateFunction}
        padding="0 40px"
      >
        <div style={{ textAlign: 'center', }} dangerouslySetInnerHTML={{ __html: bannerContent }} />
        <Badge src={badge} alt="Novità" />
      </ContainerFlex>
    </FlexChild>
  );
};

HomeBanner.propTypes = {
  color: PropTypes.string,
  bgcolor: PropTypes.string,
  border: PropTypes.string,
  radius: PropTypes.string,
  bannerContent: PropTypes.string.isRequired,
  navigateFunction: PropTypes.func,
};

export default HomeBanner;
